import React from "react";
import ProductsSection from "../components/ProductsSection";
import ComparisonTable from "../components/ComparisonTable";
import Testimonials from "../components/Testimonials";
import { useLocation } from "react-router-dom";
import { CONTENT_TYPES } from "../constants/contentTypes";
import AutoScrollingImages from "../components/AutoScrollingImages";
import IndustrialVersatileSurfaces from "../components/IndustrialVersatileSurfaces";
import OurProductLine from "../components/OurProductLine";
import MadeInAmerica from "../components/MadeInAmerica";

const Products = () => {
  const location = useLocation();
  const isIndustrial = location.pathname.startsWith('/industrial');
  const isProductsPage = location.pathname.includes('/products');

  return (
    <>
      <OurProductLine />
      <div id="our-products">
        <ProductsSection 
          contentType={isIndustrial ? CONTENT_TYPES.PROFESSIONAL : CONTENT_TYPES.HOUSEHOLD}
          title={isIndustrial ? 'Industrial Products' : 'Household Products'}
          isProfessional={isIndustrial}
          showQuoteButton={isIndustrial && isProductsPage}
        />
        <MadeInAmerica />
      </div>
      {isIndustrial ? (
        <IndustrialVersatileSurfaces />
      ) : (
        <>
          <AutoScrollingImages />
          <ComparisonTable />
          <Testimonials />
        </>
      )}
    </>
  );
};

export default Products;
